module.exports = __webpack_public_path__ + "img/culture_3.1e6642b5.jpg";